import * as React from "react";

// Mobile-first: Mobile is default, desktop starts at 768px (Tailwind's 'md' breakpoint)
const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    // Mobile-first: Use min-width to detect desktop (not max-width for mobile)
    // This matches Tailwind's mobile-first approach
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      // Mobile-first: true if width < breakpoint (mobile), false if >= breakpoint (desktop)
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    // Set initial value (mobile-first: assume mobile until proven otherwise)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
